// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"ja_a bii_vu bii_ql bii_va bii_gy bii_kg bii_sv","ProfileAdminTools__item":"ja_b"};